// Runtime config — loaded from /env-config.js (envsubst'd at container start
// from app/web/env-config.template.js using Cloud Run env vars) by index.html
// before the Vite bundle runs. See env-config.template.js for the schema.
//
// All code should read env-driven values via this module, never directly
// from window.__APP_CONFIG__, so:
//   - defaults live in one place
//   - TypeScript catches typos
//   - local dev (where /env-config.js is the stub from public/) still works

type AppConfig = {
  apiUrl: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export const config: AppConfig = {
  // Empty = same-origin. The CRM's fetch paths already include the /api
  // prefix, which the Vite dev proxy (local) and nginx (deployed) forward to
  // the API service. Set window.__APP_CONFIG__.apiUrl only for browser-direct
  // dev against a different API origin.
  // `typeof window` rather than `window` directly: this module is imported
  // transitively by most of the app, and reading a bare `window` throws a
  // ReferenceError outside a browser — which made every module downstream of it
  // impossible to unit test, telemetry and the whole api layer included.
  apiUrl:
    (typeof window !== 'undefined' ? window.__APP_CONFIG__?.apiUrl : undefined) ?? '',
};
